<template>
  <div class="tw-w-full tw-h-full tw-bg-exam-dark" />
</template>

<script>
export default {
  name: 'ExaminerVideo',
};
</script>
